import { useForm } from '@inertiajs/react';
import React, { useRef, useState } from 'react';
import useRoute from '@/Hooks/useRoute';
import Modal from '@/Components/Display/Modal';
import Input from '@/Components/Inputs/Input';
import Button from '@/Components/Buttons/Button';
import FormSection from '@/Blocks/Forms/FormSection';

export default function DeleteUserForm() {
  const route = useRoute();
  const [confirmingUserDeletion, setConfirmingUserDeletion] = useState(false);
  const passwordRef = useRef(null);

  const form = useForm({
    password: '',
  });

  function confirmUserDeletion() {
    setConfirmingUserDeletion(true);

    setTimeout(() => passwordRef.current?.focus(), 250);
  }

  function deleteUser() {
    form.delete(route('current-user.destroy'), {
      preserveScroll: true,
      onSuccess: () => closeModal(),
      onError: () => passwordRef.current?.focus(),
      onFinish: () => form.reset(),
    });
  }

  function closeModal() {
    setConfirmingUserDeletion(false);
    form.reset();
  }

  return (
    <FormSection
      title={'Delete Account'}
      description={'Permanently delete your account.'}
    >
      <div className="col-span-2 text-base text-dark">
        Once your account is deleted, all of its resources and data will be
        permanently deleted. Before deleting your account, please download any
        data or information that you wish to retain.
      </div>

      <div className="col-span-2 mt-5">
        <Button onClick={confirmUserDeletion} style="admin" variant="error">
          <p className="w-full text-lg text-white">Delete Account</p>
        </Button>
      </div>

      {/* <!-- Delete Account Confirmation Modal --> */}
      {confirmingUserDeletion && (
        <Modal
          modalState={confirmingUserDeletion}
          onClose={closeModal}
          modalHeader="Delete Account"
          modalSubHeader="Are you sure you want to delete your account? Once your account is
                deleted, all of its resources and data will be permanently deleted.
                Please enter your password to confirm you would like to permanently
                delete your account."
        >
          <div className="bg-light">
            <div className="mt-4">
              <Input
                type="password"
                className="mt-1 block w-3/4"
                placeholder="Password"
                value={form.data.password}
                onChange={e => form.setData('password', e.currentTarget.value)}
                label="Password"
                error={form.errors.password}
              />
            </div>
            <div className="mt-6 grid grid-cols-1 items-center justify-end gap-6 lg:grid-cols-4">
              <div div className="col-span-1 sm:col-span-1">
                <Button style="border" variant="grey" onClick={closeModal}>
                  Cancel
                </Button>
              </div>
              <div className="col-span-1 lg:col-span-3">
                <Button
                  disabled={form.processing}
                  onClick={deleteUser}
                  type="submit"
                  style="admin"
                  variant="error"
                >
                  Delete Account
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </FormSection>
  );
}
